import React from "react";

function Tab({ state, title, toggle }) {
  return (
    <button
      onClick={toggle}
      className={`${state ? "" : "inactive"} p-0 bg-transparent text-white flex w-auto cursor-pointer min-w-0 flex-col border-none `}
    >
      <p className="mb-[10px] font-bold leading-none">{title}</p>
      <div className="h-2 w-full rounded-full bg-primary"></div>
    </button>
  );
}

export default Tab;
